// extracted by mini-css-extract-plugin
export var flushBottom = "eLoSj4l3II3wpe2DmDXv";
export var flushLeft = "BPd9jVzIyNn9lLr_cwZ5";
export var flushRight = "PIaKFWP3xdlpaHGWWMlI";
export var flushTop = "jHo8ir04yuOyP2rDAzGf";
export var label = "MapvfbRT5fel0TsTQ3fG";
export var leadingItem = "to8qjGhHzadxQCEhPMuD";
export var onClick = "DT8ZIo8URAekcHseNqnk";
export var smallSpacing = "Lz80Ta2sjFmRMB_59cBI";
export var tag = "DHOqGSDp_f1VuwILtwbe";
export var trailingItem = "zNkyd2a9bOJRz6b8OBon";